import React from 'react';
import history from '@src/common/history';
import { classnames, getValueDepth1, openTargetBlankPage } from '@src/utils';
import { HOME_TAB_KEY_FOLLOW } from '@src/utils/constant/home';
import { QuestionSimpleInfo, FollowQuestionOrAnswerInfo } from '@src/services';
import { IconFont } from '@src/features/common';
import { SFCItemOption } from '@src/features/common/components';
import moment from 'moment';
import SFCTitleContent from './SFCTitleContent';
import './SFCQuestionTextImage.less';

interface Props {
  data: any;
  index: number;
  tabKey?: string;
  onFollow: (data: { questionId: number; index: number; currentType: boolean }) => void;
  enableTargetBlank?: boolean;
  openTargePage?: (targetUri: string) => void;
  handleRemove?: () => void;
  showOption?: boolean;
  /** 是否是最热提问 */
  hot?: boolean;
  /** 是否需要置顶功能 */
  pinned?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
  /** 是否是首页调用 */
  home?: boolean;
  /** 置顶函数 */
  askSticky?: (stickType: number, articleOrQuestionId: number) => void;
}

const SFCQuestionTextImage: React.SFC<Props> = (props: Props) => {
  const openTargePageDefault = (targetUri: string) => {
    if (!props.enableTargetBlank) {
      history.push(targetUri);
    } else {
      openTargetBlankPage(targetUri);
    }
  };

  const {
    data,
    index,
    tabKey,
    openTargePage = openTargePageDefault,
    handleRemove,
    showOption,
    hot = false,
    pinned = false,
    isAdmin = false,
    askSticky,
    home = false
    // onDelete
  } = props;

  const onQuestion = () => {
    openTargePage(`/ask/info/${data.questionId}`);
  };

  const onProfile = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    openTargePage(`/personal/${data?.user?.username}`);
  };

  const onFollow = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    props.onFollow({ questionId: data.questionId || 0, index, currentType: !!data.hasFollow });
  };

  const handleEdit = () => {
    openTargePage(`/ask/ask-edit/${data.status}/${data.questionId}`);
  };

  // const handleDelete = (item: QuestionSimpleInfo) => {
  //   removeAskAsync({
  //     params: { questionId: item.questionId || 0, type: item.status || '' },
  //     pageNum: page,
  //     pageSize: PAGE_SIZE,
  //     targetUser,
  //     callBack: () => {
  //       if (askListModel.list && askListModel.list.length === 1 && page !== 1) {
  //         changePageNum(page - 1);
  //       }
  //     }
  //   });
  // }

  /** 置顶函数 */
  const stickyAsk = (stickType: number, articleOrQuestionId: number) => {
    askSticky && askSticky(stickType, articleOrQuestionId);
  };
  const actionTypeMap = {
    1: {
      text: (
        <>
          <span
            className="k-tech-cursor-pointer k-tech-hover-underscore"
            onClick={onProfile}
          >{`${getValueDepth1(data.user, 'name')}`}</span>{' '}
          的提问
        </>
      )
    },
    4: {
      text: (
        <>
          <span
            className="k-tech-cursor-pointer k-tech-hover-underscore"
            onClick={onProfile}
          >{`${getValueDepth1(data.user, 'name')}`}</span>{' '}
          评论过的提问
        </>
      )
    },
    6: { text: `在 ${data.actionCommonInfo} 圈子的提问` },
    7: { text: `在 ${data.actionCommonInfo} 团队的提问` },
    8: { text: `${data.actionCommonInfo}标签的提问` }
  };

  return (
    <div className="k-tech-feed-item k-tech-com-question-text-image">
      {tabKey === HOME_TAB_KEY_FOLLOW && (
        <div className="tip">
          {!!data.actionType &&
            !!actionTypeMap[data.actionType] &&
            actionTypeMap[data.actionType].text}
        </div>
      )}
      <div className="k-tech-cursor-pointer" onClick={onQuestion}>
        <SFCTitleContent
          title={data.title || ''}
          content={data.subContent || ''}
          hot={hot}
          hotIndex={index + 1}
          pinned={pinned}
          isAdmin={isAdmin}
          id={data.questionId || 0}
          stickyFlag={data.stickFlag || 0}
          stickyAsk={stickyAsk}
        />
      </div>

      <div className="bottom">
        <div className="bottom-left">
          <div className="meta">
            <span
              className="k-tech-hover-underscore k-tech-cursor-pointer name"
              onClick={onProfile}
            >
              {data?.user?.name}
            </span>

            {(data.publishUpdateTime || data.lastUpdateTime) && (
              <div className="when-box">
                <span className="shu"></span>
                <span className="when-question">
                  提问于{' '}
                  {data.publishUpdateTime
                    ? moment(data.publishUpdateTime).format('MM/DD')
                    : moment(data.lastUpdateTime).format('MM/DD')}
                </span>
              </div>
            )}
          </div>

          <ul className="action">
            <li className="k-tech-cursor-pointer action__item" onClick={onFollow}>
              {data.hasFollow ? '已关注' : '关注'}
            </li>
          </ul>

          <ul className="more">
            <li className="answer">
              <IconFont type={`icon-answer`} /> 回答 {data.answerCount || 0}
            </li>
          </ul>
        </div>
        <div className="bottom-right">
          {showOption && (
            <SFCItemOption
              className="ques__options"
              handleEdit={handleEdit}
              handleRemove={() => {
                handleRemove && handleRemove();
              }}
            />
          )}
          {/* 收藏 暂时取消 */}
          {/* <IconFont type="icon-lable" className="favorite-icon" /> */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SFCQuestionTextImage);
